import { IS_APP } from "@/__main__/constants.mjs";
import router from "@/__main__/router.mjs";
import appRefs from "@/app/refs.mjs";
import { shouldShowAppNavigation } from "@/util/app-route.mjs";

const loadingMap = new Map();

async function loaderFn<K extends keyof typeof appRefs.appShell>(
  key: K,
  fn: () => Promise<{ default: (typeof appRefs.appShell)[K] }>,
) {
  if (loadingMap.get(key)) return;
  loadingMap.set(key, true);

  try {
    appRefs.appShell[key] = (await fn()).default;
  } catch (e) {
    loadingMap.set(key, false);
  }
}

export default async function initAppShell() {
  const appNav = shouldShowAppNavigation(router.lastPathname);
  await Promise.all([
    IS_APP && loaderFn("TitleBar", () => import("@/app/AppShellTitleBar.jsx")),
    appNav &&
      loaderFn(
        "AppHeaderNotification",
        () => import("@/app/AppHeaderNotification.jsx"),
      ),
    appNav &&
      loaderFn("ContentHeader", () => import("@/app/ContentHeader.jsx")),
    appNav && loaderFn("Snackbar", () => import("@/app/Snackbar.jsx")),
    IS_APP &&
      loaderFn(
        "GamePromoFeatures",
        () => import("@/app/GamePromoFeatures.jsx"),
      ),
    // TODO @lyricwulf
    // appNav &&
    //   loaderFn("OmniSearchModal", () => import("@/search/OmniSearchModal.jsx")),
  ]);
}
